import React, { Component } from 'react'
import { Route } from 'react-router-dom';
import { Container } from 'react-bootstrap';

import AuthBridge from '../app/auth/AuthBridge';
import AuthConnect from '../app/auth/AuthConnect';
import EmailVerify from '../app/auth/EmailVerify';
import AuthPasswordReset from '../app/auth/AuthPasswordReset';
import RegistroBridge from '../app/auth/registration/RegistroBridge';
import AuthForgotPasswordEmail from '../app/auth/AuthForgotPasswordEmail';
import AuthExternalSearhDomain from '../app/auth/AuthExternalSearhDomain';
import RegistroSinCompra from '../app/auth/registration/RegistroSinCompra';
import RegistroConCompra from '../app/auth/registration/RegistroConCompra';

class AuthLayout extends Component {

  render() {
    return (
      <Container className="auth-layout-container" fluid={ true }>
        <div className="justify-content-center align-items-center">
          <div className="auth-layout-container-box">
            <Route path="/auth/external" component={ AuthExternalSearhDomain } />
            <Route path="/auth/connect" component={ AuthConnect } />
            <Route path="/auth/login" component={ AuthBridge } />
            <Route path="/auth/registro/simple" component={ RegistroSinCompra } />
            <Route path="/auth/registro/compra" component={ RegistroConCompra } />
            <Route path="/auth/registro" component={ RegistroBridge } exact />
            <Route path="/auth/password/email" component={ AuthForgotPasswordEmail } />
            <Route path="/auth/password/reset/credentials" component={ AuthPasswordReset } exact />
            <Route path="/auth/verify/:id/:hash" component={ EmailVerify } exact />
          </div>
        </div>
      </Container>
    )
  }

}

export default AuthLayout;